import * as React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import apiRequest from '../../hooks/ApiRequest';
const data=[];
// const data = [
//   {
//     name: 'Jan',
   
//     policies: 1,
//   },
//   {
//     name: 'Feb',
   
//     policies: 20,
//   },
//   {
//     name: 'Mar',
    
//     policies: 3,
//   },
//   {
//     name: 'Apr',
   
//     policies: 4,
//   },
//   {
//     name: 'May',
   
//     policies: 5,
//   },
//   {
//     name: 'Jun',
    
//     policies: 6,
//   },
//   {
//     name: 'Jul',
   
//     policies: 100,
//   },
//   {
//     name: 'Aug',
  
//     policies: 1,
//   },
//   {
//     name: 'Sep',
  
//     policies: 20,
//   },
//   {
//     name: 'Oct',
    
//     policies: 0,
//   },
//   {
//     name: 'Nov',
    
//     policies: 12,
//   },
//   {
//     name: 'Dec',
   
//     policies: 1, 
//   },
// ];
class Barchart extends React.Component {
  static jsfiddleUrl = 'https://jsfiddle.net/alidingling/90v76x08/';
  constructor() {
    super()
    this.state = {

      chardata:[]
    }
  }
  async componentDidMount() {
    try {
      const response = await apiRequest(`${process.env.REACT_APP_BASE_URL}/policy/GetBarchart`, 'GET');
  
      if (response.success) {
        this.setState({ chardata: response.data });
      } else {
        console.error("API Error:", response.error);
        // message.error(response.error || "Failed to fetch chart data.");
      }
    } catch (error) {
      console.error("Request failed:", error);
      // message.error("Something went wrong. Please try again.");
    }
  }
  
  render () {
    const iconName = `/static/images/icon-${this.props.icon}.png `;
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={this.state.chardata}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip cursor={false}/>
          <Legend />
          <Bar dataKey="policies" stackId="a" fill="#5984EE" />
          {/* <Bar dataKey="uv" stackId="a" fill="#45CD93" /> */}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
export default Barchart;
